import { CardThreeIcon } from '../icons/CardThreeIcon';

import { useLocalization } from 'localization';
import IconButton from '../button/IconButton';
import routes from 'app.routes';

type Props = {
  disabledMaterial: boolean;
  caseId: string;
};

const CasePresentationMenu = (props: Props) => {
  const { disabledMaterial, caseId } = props;
  const { t } = useLocalization();

  const handleClick = () => {
    const url = routes.v2.presentation(caseId);
    window.open(url, '_blank');
  };

  return (
    <IconButton
      icon={<CardThreeIcon width={20} height={20} />}
      title={t('common.actions.present')}
      onClick={event => {
        event.stopPropagation();
        handleClick();
      }}
      size="large"
      disabled={disabledMaterial}
    />
  );
};

export default CasePresentationMenu;
